import React, {useContext, useEffect} from "react";
import {Controller, useForm} from "react-hook-form";
import DatePickerWrapper from "@components/DataPickerWrapper";
import {LavoratoreOrarioDistribuzioneRecord} from "@commons/mapping/LavoratoreOrarioDistribuzioneRecord";
import {FPNetDate} from "@commons/types";
import CheckboxEx from "@components/wrapperComponents/CheckboxEx";
import {ComboBoxTurno} from "@components/comboBox/ComboBoxTurni";
import {PresenzeContext} from "@commons/hooks/usePresenze";
import Select from "@components/wrapperComponents/Select";
import {giorniSettimana} from "../calendario.GestionePLUS";
import FormButtons from "@components/FormButtons";

interface NuovaDistribuzioneProps {
    dtGiornata: FPNetDate,
    onCancel: () => void,
}

interface weekDays {
    lunedi: number,
    martedi: number,
    mercoledi: number,
    giovedi: number,
    venerdi: number,
    sabato: number,
    domenica: number
}

interface FormNuovaDistribuzione extends LavoratoreOrarioDistribuzioneRecord {
    applyFilter: boolean,
    week: weekDays,
    mostraTuttiValori: boolean,
}

const NuovaDistribuzione: React.FC<NuovaDistribuzioneProps> = ({dtGiornata, onCancel}) => {

    const form = useForm<FormNuovaDistribuzione>({});
    const {watch, resetField, control, register,} = form;

    const {
        consolidatedData,
        ...gestione
    } = useContext(PresenzeContext);

    const filterActivated = watch('applyFilter');

    useEffect(() => {
        if (!filterActivated)
            resetField('week')
    }, [resetField, filterActivated]);

    const addFilterDistribuzione = () => {
    }

    return <div className="w-full mt-2 py-2 px-3 rounded-lg border border-gray-200 shadow-lg">
        <div className="grid grid-cols-3">
            <CheckboxEx name="applyFilter" divClassName="col-start-2" control={control} label="Applica filtro"/>
        </div>

        {filterActivated && <div className="grid grid-cols-3 mt-2">
            <div className="col-span-3 gap-x-2 inline-flex mx-auto">
                {giorniSettimana.map((item: string, index: number) => (
                    <CheckboxEx divClassName="place-content-center" control={control} label={item} key={index}
                                onClick={() => addFilterDistribuzione}
                        // @ts-ignore
                                name={`week.${item}`}
                    />))}
            </div>
        </div>}

        <div className="inline-flex w-full mt-2">
            <div>
                <label className="block text-sm font-semibold mb-1" htmlFor="decorrenzaTurno">Decorrenza</label>
                <Controller name="decorrenzaTurno" control={control} defaultValue={dtGiornata}
                            render={({field: {value, onChange}, fieldState, formState}) =>
                                (<DatePickerWrapper fieldState={fieldState} value={value} onChange={onChange} enabled={false}/>)
                            }/>
            </div>

            <div className="w-2/4 mx-auto">
                <ComboBoxTurno control={control} name="turno" defaultValue={null} label="Turno" data={undefined}/>
            </div>

            <div className="w-1/4">
                <Select register={register} name="turnazione" defaultValue={undefined} label="Turnazione" divClass="">
                    {<option>{}</option>} {/* map! */}
                </Select>
            </div>
        </div>

        <div className="grid grid-cols-3 mt-4">
            <CheckboxEx name="mostraTuttiValori" label="Mostra tutti gli orari/turni" divClassName="text-gray-500"
                        onClick={() => {
                        }} control={control}/>
        </div>

        <FormButtons onCancel={onCancel} traceInfo={false}/>
    </div>
}
export default NuovaDistribuzione;